// analytics-frontend client:
import client, { Client } from './client';
import initializer from './initializer';
import globalizeApi from './globalizeApi';
import { INIT_TIMEOUT_THRESHOLD } from './constants';
import { WtaEndpointResponse } from './throttler';

// Send client to the global scope, wrapped in an async mechanism:
globalizeApi(client);

// Start countdown to ensure init happens in a timely manner:
initializer.initFailureCountdown(INIT_TIMEOUT_THRESHOLD);

export { client, Client };

// Types utilized in client.event data objects:
export {
    InteractionTypes,
    CheckTypes,
    CardEngagement,
    SlotRender,
    VideoEvent,
    ActionStart,
    ActionEnd,
    ActionReady,
    PaymentMethod,
    Currency,
    ProductType,
    ProductSpecs,
    CheckoutFlowType,
    TransactionStartData,
    TransactionCompleteData,
    PaperUploadStartData,
    PaperUploadEndData,
    PaperReadyData,
    PaperUploadData,
    CheckStart,
    CheckEnd,
    PaperCheckStart,
    PaperCheckEnd,
    TransactionData,
    EventData,
    EventType,
    EventSpecs,
    EventConfig
} from './eventTypes';

export {
    AppId,
    Property,
    SubscriptionStatus,
    SessionData,
    AuthState,
    TestCell,
    TestCellArray,
} from './initializer';

export {
    StateUpdateWhitelistObject,
} from './stateManager'

// Types for use of global client interface:
export {
    WtaCmdCb,
    WtaCmd,
    WtaState,
} from './globalizeApi';

// Types for using Adobe data:
export {
    AdobeData,
    AdobeDataResponse,
} from './adobeUtils';

// Type returned from sending event:
export type AfResponse = WtaEndpointResponse;

// Export business-logic static values for use in the apps:
export {
    AUTH_STATE,
    SUBSCRIPTION_STATUS,
} from './constants';

// The contract of the payload relayed to the backend collection point:
export {
    EventPayload,
} from './structureData';
